import  React, { useEffect, useState } from 'react';

import { HelpBox } from './help_box.jsx';

const labelMap = {
  "kg": {
    "METRIC": "kg",
    "IMPERIAL": "pounds"
  },
  "m/s": {
    "METRIC": "m/s",
    "IMPERIAL": "ft/s"
  },
  "m": {
    "METRIC": "m",
    "IMPERIAL": "ft"
  }
}

export const NumInput = ({
    id,
    label,
    onInputChange,
    value,
    min = "",
    max = "",
    maxLength,
    minValue,
    maxValue,
    labelDetail = "",
    valid,
    validityTester,
    helpText,
    units = "METRIC",
    mandatory = false
  }) => {
  
  const [maxDate, setMaxDate] = useState(max)

  useEffect(()=>{
    // Logic to set current year as max value.
    if(max===0){
      const newDate = new Date().getFullYear()
      setMaxDate(newDate)
    }
  },[])

  let mappedLabel = labelDetail;
  if (labelMap[labelDetail] && labelMap[labelDetail][units]) {
    mappedLabel = labelMap[labelDetail][units];
  }

  let validityLabel = `${min}-${maxDate}${min || maxDate ? " " : ""}${mappedLabel}`;

  let labelItem = (
      <label className="input-label">
        {label}{mandatory && <span className="mandatory-asterix"> *</span>}
        <span className="validity-label">{validityLabel}</span>
      </label>
    );

  if(valid != false){
    valid = true;
  }

  let inputValueChange = (value) => {
    var valid = true;

    if (value != '' && maxDate && min && (value > maxDate || value < min)){
      valid = false;
    } else if (min == 0 && maxDate && value > maxDate) {
      valid = false;
    }
    onInputChange({value, valid});
  };

  let inputItem;

    inputItem = (
      <NumInputField
        className="num-field"
        id={id}
        onInputChange={ inputValueChange }
        value={ value }
        maxLength={ maxLength }
        minValue={minValue}
        maxValue={maxValue}
        valid={valid}
        validityTester={validityTester}
      />
    );

  return(
    <div id={id}>
      <div className="general-num-field input-item">
        {inputItem}
        {labelItem}
      </div>
      { helpText ?
        <HelpBox data={[
          {
            text: helpText
          }
        ]}/> : null
      }
    </div>
  );
};

const NumInputField = ({id, onInputChange, value, maxLength, valid, validityTester}) => {


  const validateNumberInputKeyPress = (evt, valLength) => {
    const charCode = evt.charCode ? evt.charCode : evt.keyCode;
    if(charCode != 0 && (charCode < 48 || charCode > 57) && charCode != 46){
      evt.preventDefault();
    }
    else if(valLength === maxLength){
      evt.preventDefault();
    }

  };

  const validateNumberInput = (input) => {
    if(/^(0|[1-9][0-9]*)(\.[0-9]{0,2})?$|^\.$/.test(input) || input === ''){
      if(input[0] == 0 && input.length > 1){
        if (input[1] != ".")
          return;
      }
      if(input[0] == '.'|| input[maxLength-1] == '.') return
      if(input !== '' && validityTester && !validityTester(input)){
        return;
      }
      onInputChange(input);
    }
  };

  return(
      <input
        className={"input " + (valid ? "" : "invalid")}
        type="tel"
        onKeyPress={(event) => validateNumberInputKeyPress(event, value.length)}
        onInput={ ({target} ) => validateNumberInput(target.value) }
        onChange={() => {}}
        value={ value }
        id={id + "Input"}
        maxLength={maxLength}
      />
  );
};
